export default __webpack_public_path__ + "static/media/icon-info-circle-outline.3eb3370f.svg";